import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteNote, IUpdateNoteParams } from '../../actions/favoriteEntities/notes';
import { DeleteButton, IDeleteButtonProps } from '../../components/DeleteButton';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { trackCommentDelete } from './trackings';

type TStoreProps = Pick<IDeleteButtonProps, 'showPreloader'>;
type TDispatchProps = Pick<IDeleteButtonProps, 'onDeleteCommentClick'>;
type TOwnProps = Pick<IUpdateNoteParams, 'entityId'>;

function mapStateToProps({ results: { deletingNotes } }: IApplicationState, { entityId }: TOwnProps) {
  return {
    showPreloader: deletingNotes.find(id => id === entityId) || false,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch, { entityId }: TOwnProps) {
  const params = { entityId, comment: '' };

  return {
    onDeleteCommentClick: bindActionCreators(() => deleteNote(params), dispatch),
  };
}

function mergeProps(state: TStoreProps, actions: TDispatchProps, ownProps: TOwnProps) {
  return {
    ...state,
    ...actions,
    ...ownProps,
    onDeleteCommentClick: () => {
      actions.onDeleteCommentClick();
      trackCommentDelete();
    },
  };
}

export const DeleteCommentButtonContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeleteButton);
